import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=f72a5302"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=f72a5302&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports